module.exports = __webpack_public_path__ + "static/media/38.c2a546ec.png";